import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAnjq8TRXXcBFlTuW7AJjAHDaDg1P_uAvE",
  authDomain: "digital-postage.firebaseapp.com",
  projectId: "digital-postage",
  storageBucket: "digital-postage.firebasestorage.app",
  messagingSenderId: "1060668406824",
  appId: "1:1060668406824:web:5d5ff1bfec40b9101f891d"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);